import React, { FunctionComponent, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { useMutation, useQuery } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
// import useMediaQuery from '@mui/material/useMediaQuery';

// import { check_subdomain } from '../../lib/server_helper';
import { fetch_all_with_count } from "../../../lib/v31lib";
import { loginAtom } from '../../../lib/auth';
import { currentPracticeAtom } from '../../../lib/practice';

import BuildIcon from '@mui/icons-material/Build';

import {
  Avatar,
  Box,
  CircularProgress,
  Grid,
  ImageListItem,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Pagination,
  Paper,
  Stack,
} from '@mui/material';

import {
  Button,
  Dt,
  ImageList,
  Page,
  Typography
} from '../../../components/v2/styled';

import { KnowledgeCourse } from '../../../models/KnowledgeCourse';

import HelpersLanguage from '../../../actions/helpers/language';
import { CardCourse } from '../../../components/v2/cards/Course';

// const { DateTime } = require("luxon");

type Props = {}

export const ClientKnowledgeCenter: FunctionComponent<Props> = ({}) => {
  const [login, setLogin] = useAtom(loginAtom);
  const [currentPractice, setCurrentPractice] = useAtom(currentPracticeAtom);
  const theme = useTheme();
  const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);

  let count = 0;
  let finishedCount = 0;
  let otherCount = 0;
  const [page, setPage] = useState<number>(0);
  const [order, setOrder] = useState<string>("created_at DESC");
  const [search, setSearch] = useState<string>("");

  const [destroyedOpen, setDestroyedOpen] = useState<boolean>(false);

  const {
    data: objects,
    isLoading: objectsLoading,
    isError: objectsError,
    isSuccess: objectsSuccess,
    refetch: objectsRefetch,
  } = useQuery({
    queryKey: ["client", "active_knowledge_courses", (login?.id), {page: page, order: order, search: search}],
    queryFn: () =>
      fetch_all_with_count<KnowledgeCourse>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'knowledge_course',
          fields: ['id', 'full_name', 'full_teaser', 'extra_data', 'get_item', 'is_bg_color', 'practice', 'knowsub', 'is_nutri', 'is_it'],
          sub_fields: {
            practice: ['id', 'name', 'get_item'],
            knowsub: ['id', 'created_at', 'lesson_key', 'lesson_data', 'is_approved']
          },
          order: order,
          per_page: 200,
          page: page,
          filter: {
            search: search,
            advanced: {
              for_client: login?.id,
              participating: 1,
              skip_hidden: 1
            }
          }
        },
        login
      ),
    select: (d) => {
      count = d.count;
      return d.result;
    },
    enabled: !!login?.id
  });

  const {
    data: finishedObjects,
    isLoading: finishedObjectsLoading,
    isError: finishedObjectsError,
    isSuccess: finishedObjectsSuccess,
    refetch: finishedObjectsRefetch,
  } = useQuery({
    queryKey: ["client", "finished_knowledge_courses", (login?.id), {page: page, order: order, search: search}],
    queryFn: () =>
      fetch_all_with_count<KnowledgeCourse>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'knowledge_course',
          fields: ['id', 'full_name', 'full_teaser', 'extra_data', 'get_item', 'is_bg_color', 'practice', 'is_nutri', 'is_it', 'knowsub'],
          sub_fields: {
            practice: ['id', 'name', 'get_item'],
            knowsub: ['id', 'created_at', 'lesson_key', 'lesson_data', 'finished_at']
          },
          order: order,
          per_page: 20,
          page: page,
          filter: {
            search: search,
            advanced: {
              for_client: login?.id,
              finished: 1
            }
          }
        },
        login
      ),
    select: (d) => {
      finishedCount = d.count;
      return d.result;
    },
    enabled: !!(login?.practice_id || currentPractice?.id),
  });

  const {
    data: otherObjects,
    isLoading: otherObjectsLoading,
    isError: otherObjectsError,
    isSuccess: otherObjectsSuccess,
    refetch: otherObjectsRefetch,
  } = useQuery({
    queryKey: ["client", "other_knowledge_courses", (login?.id), {page: page, order: order, search: search}],
    queryFn: () =>
      fetch_all_with_count<KnowledgeCourse>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'knowledge_course',
          fields: ['id', 'full_name', 'full_teaser', 'extra_data', 'get_item', 'is_bg_color', 'practice', 'is_nutri', 'is_it'],
          sub_fields: {
            practice: ['id', 'name', 'get_item']
          },
          order: order,
          per_page: 1,
          page: page,
          filter: {
            search: search,
            advanced: {
              for_client: login?.id,
              not_participating: 1
            }
          }
        },
        login
      ),
    select: (d) => {
      otherCount = d.count;
      return d.result;
    },
    enabled: !!(login?.practice_id || currentPractice?.id),
  });







  // const mutationDestroy = useMutation({
  //   mutationFn: (pars: {
  //     formData: any;
  //   }) => {
  //     return fetch_one<KnowledgeCourse>(
  //       `/${i18n.resolvedLanguage || 'nl'}/v3/objects/remove`,
  //       pars.formData,
  //       login
  //     );
  //   },
  //   onMutate: (pars: {
  //     formData: any;
  //   }) => {
  //     return true;
  //   },
  //   onError: (data, variables, context) => {
  //     return true;
  //   },
  //   onSuccess: (data, variables, context) => {
  //     setDestroyedOpen(true);
  //     objectsRefetch();
  //   },
  // });








  return <Page title={t("client.menu.knowledge_center")}>
    <Grid container spacing={1}>
      {!!objectsLoading && <Grid item xs={12}>
        <Box>
          <Typography variant={"subtitle1"}>{t("client.knowledge_center.active_courses")}</Typography>
          <Paper sx={{
            padding: 2
          }}>
            <CircularProgress />
          </Paper>
        </Box>
      </Grid>}
      {!!objectsSuccess && objects?.length > 0 && <Grid item xs={12}>
        <Box>
          <Typography variant={"subtitle1"}>{t("client.knowledge_center.active_courses")} ({count})</Typography>
          <ImageList cardWidth={400}>
            {(objects || []).map(course => <ImageListItem key={course.id} sx={{
              height: "auto !important"
            }}>
              <CardCourse
                course={course}
                hideHeader
              />
            </ImageListItem>)}
          </ImageList>
        </Box>
      </Grid>}
      {!!objectsSuccess && objects?.length === 0 && <Grid item xs={12}>
        <Box>
          <Typography variant={"subtitle1"}>{t("client.knowledge_center.active_courses")} ({count})</Typography>
          <Typography sx={{
            fontStyle: 'italic',
            color: 'lightgrey',
            textAlign: 'center'
          }}>{t("client.knowledge_center.no_active_courses")}</Typography>
        </Box>
      </Grid>}

      <Grid item xs={12}>
        <Button
          label={t("client.knowledge_center.courses_cta", {amount: otherCount})}
          id="goto_courses"
          contained
          onClick={() => {
            navigate("/knowledge_courses");
          }}
          // startIcon={}
        />
      </Grid>

      {!!finishedObjectsLoading && <Grid item xs={12}>
        <Box>
          <Typography variant={"subtitle1"}>{t("client.knowledge_center.past_courses")}</Typography>
          <Paper sx={{
            padding: 2
          }}>
            <CircularProgress />
          </Paper>
        </Box>
      </Grid>}
      {!!finishedObjectsSuccess && finishedObjects?.length > 0 && <Grid item xs={12}>
        <Box>
          <Typography variant={"subtitle1"}>{t("client.knowledge_center.past_courses")} ({finishedCount})</Typography>
          <Paper sx={{
            padding: 2
          }}>
            <List>
              {finishedObjects.map(course => (<>
                <ListItem divider={finishedObjects.indexOf(course) < finishedObjects.length - 1} sx={{
                  // backgroundColor: 'rgba(255, 0, 0, 0.2);'
                  cursor: 'pointer'
                }} onClick={() => {
                  navigate(`/knowledge_subscription/${course.knowsub?.lesson_key}`);
                }}>
                  <ListItemAvatar>
                    <Avatar src={course.practice?.get_item}></Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={(course?.full_name || {})[HelpersLanguage.mapping_to_id(i18n.resolvedLanguage || 'nl')]}
                    secondary={<Dt d={course.knowsub?.finished_at} f="DD" />}
                  />
                </ListItem>
              </>))}
            </List>
            <Stack spacing={2} alignItems="center">
              <Pagination count={Math.ceil(finishedCount/10)} page={page + 1} onChange={(e, v) => {setPage(v - 1);}} boundaryCount={2} siblingCount={2} />
            </Stack>
          </Paper>
        </Box>
      </Grid>}



      {/* {(objects || []).map(course => <Grid item xs={12} md={4}>
        <CardCourse
          course={course}
        />
      </Grid>)}
      <Grid item xs={12}>

      </Grid>
      {(otherObjects || []).map(course => <Grid item xs={12} md={4}>
        <CardCourse
          course={course}
        />
      </Grid>)} */}
    </Grid>
  </Page>;
}
